import React, { useState, useEffect } from 'react';
import { getInventario, saveItemAlmacen, deleteItemAlmacen } from '../../../services/StoreService';
import { getCategorias, saveCategoria } from '../../../services/CategoriasService';

// Estilos
import '../../static/Global.css';
import '../../static/Home.css';
import '../../static/Aside.css';
import '../../static/Flotante.css';
import '../../static/Busqueda.css';

function DashboardAlmacen() {
    const [productos, setProductos] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [categorias, setCategorias] = useState([]);

    // 1. Agregado 'stock_min' al estado del formulario
    const [formData, setFormData] = useState({
        productos_id: '',
        nombre: '',
        categoria: '',
        precio_compra: '',
        precio_venta: '',
        stock_min: '', 
        fecha_vencimiento: '',
        imagen: '', 
        descripcion: ''
    });

    useEffect(() => {
        cargarLista();
        cargarCategorias();
    }, []);

    const cargarLista = async () => {
        try {
            const data = await getInventario(); 
            setProductos(data);
            setLoading(false);
        } catch (error) {
            console.error("Error cargando inventario:", error);
            setLoading(false);
        }
    };

    const cargarCategorias = async () => {
        try {
            const data = await getCategorias();
            setCategorias(data);
        } catch (error) {
            console.error("Error cargando categorias", error);
        }
    };

    const crearCategoria = async () => {
        const nombre = prompt("Nombre de la nueva categoría");
        if (!nombre) return;
        try {
            await saveCategoria({ nombre });
            await cargarCategorias();
            alert("Categoría creada");
        } catch (error) {
            alert("Error creando categoría");
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        try {
            await saveItemAlmacen(formData);
            alert("¡Registro de almacén actualizado!");
            closeModal();
            cargarLista();
        } catch (error) {
            alert("Error al guardar: " + error.message);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("¿Ocultar este producto del inventario?")) {
            try {
                await deleteItemAlmacen(id);
                cargarLista();
            } catch (error) {
                alert("Error al eliminar");
            }
        }
    };

    const productosFiltrados = productos.filter(p => 
        p.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
        p.productos_id.toString().includes(busqueda) ||
        p.categoria.toLowerCase().includes(busqueda.toLowerCase())
    );

    const openModal = (prod = null) => {
        if (prod) {
            setFormData({
                ...prod, 
                precio_compra: prod.precio_compra || '',
                precio_venta: prod.precio_venta || '',
                stock_min: prod.stock_min || '', // 2. Mapeamos stock_min en edición
                fecha_vencimiento: prod.fecha_vencimiento || ''
            });
        } else {
            setFormData({
                productos_id: '', 
                nombre: '', 
                categoria: '',
                precio_compra: '', 
                precio_venta: '', 
                stock_min: '', // 3. Inicializado vacío para nuevo ingreso
                fecha_vencimiento: '',
                imagen: '', 
                descripcion: ''
            });
        }
        setIsModalOpen(true);
    };

    const closeModal = () => setIsModalOpen(false);

    return (
        <section className="main__content">
            <div className="table-container">
                <div className="table-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', gap: '20px' }}>
                    <h2>GESTIÓN DE ALMACÉN</h2>
                    
                    <div className="search-container" >
                        <i className="fa fa-search" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#888' }}></i>
                        <input 
                            type="text"
                            className="search-input"
                            placeholder="Buscar por nombre, ID o categoría..."
                            style={{ paddingLeft: '35px', width: '100%', borderRadius: '8px', border: '1px solid #ddd', height: '40px' }}
                            value={busqueda}
                            onChange={(e) => setBusqueda(e.target.value)}
                        />
                    </div>

                    <button type="button" className="btn-vender-sidebar" onClick={() => openModal()}>
                        <i className="fa fa-plus"></i> Registrar en Almacén
                    </button>
                </div>

                <div className="table-responsive">
                    <table className="novatech-table">
                        <thead>
                            <tr>
                                <th>Código</th>
                                <th>Nombre</th>
                                <th>Categoría</th>
                                <th>Stock</th>
                                <th>Stock Mín.</th> 
                                <th>P. Compra</th>
                                <th>P. Venta</th>
                                <th>Vencimiento</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="9">Cargando inventario...</td></tr>
                            ) : productosFiltrados.length > 0 ? (
                                productosFiltrados.map((p) => (
                                    <tr key={p.productos_id}>
                                        <td>#{p.productos_id}</td>
                                        <td>{p.nombre}</td>
                                        <td>{p.categoria}</td>
                                        <td style={{ fontWeight: 'bold', color: p.stock > p.stock_min ? 'green' : 'red' }}>
                                            {p.stock}
                                        </td>
                                        {/* 5. Renderizado del stock mínimo en la fila */}
                                        <td style={{ color: '#666' }}>{p.stock_min ?? 0}</td>
                                        <td>S/ {Number(p.precio_compra || 0).toFixed(2)}</td>
                                        <td>S/ {Number(p.precio_venta || 0).toFixed(2)}</td>
                                        <td>{p.fecha_vencimiento || 'N/A'}</td>
                                        <td className="actions-cell">
                                            <button className="btn-edit" onClick={() => openModal(p)}>
                                                <i className="fa fa-edit"></i>
                                            </button>
                                            <button className="btn-delete" onClick={() => handleDelete(p.productos_id)}>
                                                <i className="fa-solid fa-ban"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr><td colSpan="9" style={{ textAlign: 'center', padding: '20px' }}>No se encontraron productos con "{busqueda}"</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {isModalOpen && (
                <div className="modal" style={{ display: 'flex' }}>
                    <div className="modal-content">
                        <form onSubmit={handleSave}>
                            <h2>{formData.productos_id ? "EDITAR REGISTRO" : "NUEVO INGRESO"}</h2>
                            
                            <div className="form-group">
                                <label>Nombre del Producto:</label>
                                <input type="text" value={formData.nombre} required onChange={(e) => setFormData({...formData, nombre: e.target.value})} />
                            </div>

                            <div className="form-group">
                                <label>Categoría:</label>
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    <select value={formData.categoria} required onChange={(e) => setFormData({...formData, categoria: e.target.value})}>
                                        <option value="">Seleccione categoría</option>
                                        {categorias.map((c) => (
                                            <option key={c.id} value={c.nombre}>{c.nombre}</option>
                                        ))}
                                    </select>
                                    <button type="button" className="btn-save" onClick={crearCategoria}>+</button>
                                </div>
                            </div>

                            {/* 6. Fila de precios y stock mínimo agrupados de forma limpia */}
                            <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                                <div className="form-group" style={{ flex: 1, minWidth: '120px' }}>
                                    <label>Precio Compra:</label>
                                    <input type="number" step="0.01" value={formData.precio_compra} required onChange={(e) => setFormData({...formData, precio_compra: e.target.value})} />
                                </div>
                                <div className="form-group" style={{ flex: 1, minWidth: '120px' }}>
                                    <label>Precio Venta:</label>
                                    <input type="number" step="0.01" value={formData.precio_venta} required onChange={(e) => setFormData({...formData, precio_venta: e.target.value})} />
                                </div>
                                <div className="form-group" style={{ flex: 1, minWidth: '120px' }}>
                                    <label>Stock Mínimo:</label>
                                    <input type="number" value={formData.stock_min} required onChange={(e) => setFormData({...formData, stock_min: e.target.value})} />
                                </div>
                            </div>

                            <div className="form-group">
                                <label>Fecha de Vencimiento:</label>
                                <input type="date" value={formData.fecha_vencimiento} onChange={(e) => setFormData({...formData, fecha_vencimiento: e.target.value})} />
                            </div>

                            <div className="actions">
                                <button type="submit" className="btn-save">Guardar en Almacén</button>
                                <button type="button" className="btn-cancel" onClick={closeModal}>Cancelar</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </section>
    );
}

export default DashboardAlmacen;